import React from "react";
import { Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as qiniu from "qiniu-js";
import { PlusOutlined } from "@ant-design/icons";
import * as service from "../../service";

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

async function uploadToQiniu({ action, onProgress, onSuccess, onError, file }) {
  let token = ""; // 密钥
  const resToken = await service.getUploadToken();
  token = resToken.data;
  const putExtra = { fname: file.name };
  const key = undefined; // 可以通过自己的逻辑生成key
  const observer = {
    next(res) {
      // 主要用来展示进度
      onProgress({ percent: res.total.percent });
    },
    error(err) {
      onError && onError(err);
    },
    complete(res) {
      const url = `https://wenzi.douerpiao.club/${res.key}`;
      onSuccess &&
        onSuccess({
          file: {
            uid: -1,
            url,
            thumbUrl: url,
            status: "done", // 状态有：uploading done error removed，被 beforeUpload 拦截的文件没有 status 属性
            response: { status: "success" },
          },
        });
    },
  };
  const config = {
    useCdnDomain: true,
    region: qiniu.region.z0,
  };
  const observable = qiniu.upload(file, key, token, putExtra, config);
  observable.subscribe(observer);
}

function QiniuUpload(props) {
  const { fileList } = props.value || { fileList: [] };
  console.log("fileList", fileList);
  return (
    <Upload
      name="file"
      listType="picture-card"
      beforeUpload={beforeUpload}
      customRequest={uploadToQiniu}
      {...props}
      defaultFileList={fileList}
    >
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>上传</div>
      </div>
    </Upload>
  );
}

export default QiniuUpload;
